(ns hypnos.backoffice.tile.demographics
  "Demographics tile."
  (:require [hypnos.backoffice.core.auth :as auth]
            [hypnos.backoffice.subs]
            [hypnos.backoffice.tile.field.patient-communication-preferences :as patient-communication-preferences]
            [hypnos.backoffice.tile.field.patient-contact :as patient-contact]
            ;; [hypnos.backoffice.tile.field.patient-dob :as patient-dob]
            [hypnos.backoffice.tile.field.patient-gender :as patient-gender]
            [hypnos.backoffice.tile.field.patient-image :as patient-image]
            [hypnos.backoffice.tile.field.patient-key :as patient-key]
            [hypnos.backoffice.tile.field.patient-name :as patient-name]
            [hypnos.backoffice.tile.field.patient-timezone :as patient-timezone]
            [hypnos.graphql.mutations :as mutations]
            [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- default-patient-timezone
  [state org]
  (when-not (get-in @state [:patient :patient/timezone :value])
    (swap! state
           assoc-in [:patient :patient/timezone :value]
           (:organization/timezone org))))

(defn- load
  [body]
  (if-let [_loading? @(rf/subscribe [:backoffice/gql-request-in-progress?])]
    [:div.card-content
     [:section.section
      [:div.content.has-text-grey.has-text-centered
       [:p
        [:span.icon.is-large
         [:i.mdi.mdi-loading.mdi-48px.mdi-spin]]]
       [:p (tr :ui.label/loading)]]]]
    body))

(defn- consult-contains-answers?
  "Returns true if the consult contains any answers."
  [consult]
  (or (not (nil? (get-in consult [:consult/weight :value])))
      (not (nil? (get-in consult [:consult/take-dentures-out? :value])))
      (not (nil? (get-in consult [:consult/sleep-motion? :value])))
      (not (nil? (get-in consult [:consult/mouth-breathing-level :value])))
      (not (nil? (get-in consult [:consult/eye-dryness? :value])))
      (not (nil? (get-in consult [:consult/claustrophobia-level :value])))
      (not (nil? (get-in consult [:consult/chronic-issues? :value])))
      (not (nil? (get-in consult [:consult/deviated-septum? :value])))
      (not (nil? (get-in consult [:consult/pacemaker? :value])))
      (not (nil? (seq (get-in consult [:consult/issues :value]))))
      (not (nil? (seq (get-in consult [:consult/sleep-positions :value]))))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Tile

(defn tile
  [state]
  (let [auth         (rf/subscribe [:backoffice/auth])
        organization (rf/subscribe [:backoffice/organization])
        _            (default-patient-timezone state @organization)]
    [:div.tile.is-ancestor
     ;; portrait
     [:div.tile.is-parent.is-4
      [:div.card.tile.is-child
       [:header.header.card-header
        [:p.card-header-title (tr :ui.label/portrait)]]
       [:div.card-content
        [patient-image/image]
        [:hr]]]]
     ;; demographics
     [:div.tile.is-parent
      [:div.card.tile.is-child
       [:header.header.card-header
        [:p.card-header-title (tr :ui.label/demographics)]
        (when (and (auth/iris-sleep-user? @auth)
                   (contains? #{:consult-state/new}
                              (get-in @state [:patient :patient/last-consult :consult/status :value])))
          [:button.button.is-small.is-success.is-light
           {:on-click (fn [_]
                        (let [contains-answers?  (consult-contains-answers? (get-in @state [:patient :patient/last-consult]))
                              communication-type (if contains-answers? "portrait" "consult")]
                          (rf/dispatch [:amplify/mutation
                                        mutations/send-communication
                                        {:consult_id            (str (get-in @state [:patient :patient/last-consult :consult/id :value]))
                                         :communication_channel "sms"
                                         :communication_type    communication-type}
                                        :backoffice/noop])))}
           [:span.icon.is-small [:i.mdi.mdi-message-alert]]
           [:span (tr :ui.label/re-send)]])]
       (load
        [:div.card-content
         ;; patient info
         [patient-key/field state {:disabled true}]
         [patient-name/field state {:disabled true}]
         ;; [patient-dob/field state {:disabled true}]
         [patient-gender/field state {:disabled true}]
         [patient-contact/contact-field state {:disabled true}]
         [patient-contact/alt-contact-field state {:disabled true}]
         [patient-communication-preferences/field state {:disabled true}]
         [patient-timezone/field state {:disabled true}]])]]]))
